import React, { Component } from "react";
import { Switch, Route, Link } from "react-router-dom";
import $ from "jquery";
import CustomPronunciationSubstitutions from "./CustomPronunciation";

class CustomPronunciationTabs extends Component {
  componentDidMount() {
    (function () {
      var currentPath = window.location.href;

      var path = window.origin + "/platform/cloud-tts/custom-pronunciation";
      var path1 = window.origin + "/platform/cloud-tts/custom-pronunciation/";
      if (currentPath === path || currentPath === path1) {
        $("#tts-pronunciation-tab").addClass("active");
      }
      $("#tts-pronunciation-tab").on("click", function () {
        $("#tts-pronunciation-tab").removeClass("active");
        $(this).addClass("active");
      });
    })();
  }

  render() {
    return (
      <div id="tabPage">
        <div className="content" style={{ backgroundColor: "#F9F9FB" }}>
          <div className="content-header">
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-5">
                  <h1 className="m-0 page-title">
                    Custom Pronunciation Settings
                  </h1>
                  {/* <h6 className="taglineTxt">Agent Configurations</h6> */}
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            {/* Nav tabs */}
            <div className="border-bottom"></div>
            <div className="tab-class">
              <ul className="nav nav-tabs border-bottom navCluster">
                <Link
                  className="nav-item"
                  to="/cloud-tts/custom-pronunciation"
                  style={{ textDecoration: "none" }}
                >
                  <li className="nav-link" id="tts-pronunciation-tab">
                    Pronunciation Substitutions
                  </li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
        <Switch>
          <Route
            path="/cloud-tts/custom-pronunciation"
            component={CustomPronunciationSubstitutions}
          ></Route>
        </Switch>
      </div>
    );
  }
}
export default CustomPronunciationTabs;



// WEBPACK FOOTER //
// ./src/ttsUi/CustomPronunciationTabs.js